/**
 * @generated SignedSource<<eae23e8d0bc31596caa8b732554cc187>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ResetOpportunityStageBandsInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type resetOpportunityStageBandsMutationModernMutation$variables = {
  input: ResetOpportunityStageBandsInput;
};
export type resetOpportunityStageBandsMutationModernMutation$data = {
  readonly resetOpportunityStageBands: {
    readonly company: {
      readonly " $fragmentSpreads": FragmentRefs<"opportunityStageBandsCompany_company">;
    } | null;
  } | null;
};
export type resetOpportunityStageBandsMutationModernMutation = {
  variables: resetOpportunityStageBandsMutationModernMutation$variables;
  response: resetOpportunityStageBandsMutationModernMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "resetOpportunityStageBandsMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ResetOpportunityStageBandsPayload",
        "kind": "LinkedField",
        "name": "resetOpportunityStageBands",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "opportunityStageBandsCompany_company"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "resetOpportunityStageBandsMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ResetOpportunityStageBandsPayload",
        "kind": "LinkedField",
        "name": "resetOpportunityStageBands",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                  }
                ],
                "concreteType": "OpportunityStageBandTypeConnection",
                "kind": "LinkedField",
                "name": "opportunityStageBands",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OpportunityStageBandTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OpportunityStageBand",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startPercentage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endPercentage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "winProbability",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "opportunityStageBands(first:1000)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dc24c4e37f39b6939701f87decad2d31",
    "id": null,
    "metadata": {},
    "name": "resetOpportunityStageBandsMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation resetOpportunityStageBandsMutationModernMutation(\n  $input: ResetOpportunityStageBandsInput!\n) {\n  resetOpportunityStageBands(input: $input) {\n    company {\n      ...opportunityStageBandsCompany_company\n      id\n    }\n  }\n}\n\nfragment opportunityStageBandsCompany_company on Company {\n  id\n  opportunityStageBands(first: 1000) {\n    edges {\n      node {\n        id\n        name\n        startPercentage\n        endPercentage\n        winProbability\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "028fe8995e0095c2e3f0be6119894391";

export default node;
